import React, { createContext, useEffect, useState } from "react";


export const ExamContext = createContext({
    isTesting: false as Boolean,
    examInfo: {} as ExamInfo,
    examData: [] as ExamUnit[],
    record: [] as ExamRightAnswer[],//使用者回答的紀錄
    setIsTesting: (value: boolean) => { },
    setRecord: (data: ExamRightAnswer[]) => { },
    updateRecord: (index: number, data: ExamAnswer) => { },
    setExamInfo: (data: ExamInfo) => { },
    setExamData: (data: any) => { },
});

export const ExamContextProvider = (props: any) => {
    const [isTesting, setIsTesting] = useState<Boolean>(false);
    const [examInfo, setExamInfo] = useState<ExamInfo>({} as ExamInfo);
    const [examData, setExamData] = useState<ExamUnit[]>([]);
    const [record, setRecord] = useState<ExamRightAnswer[]>([]);

    /*
    useEffect(()=>{    
    },[record])
    */
    const setBasicIsTesting = (value: boolean) => {
        setIsTesting(value)
    };


    const setBasicExamInfo = (data: ExamInfo) => {
        setExamInfo(data);
    };

    const setBasicExamData = (data: any) => {
        setExamData(data);
    };

    const setBasicRecord = (data: ExamRightAnswer[]) => {
        setRecord(data);
    };

    const updateBasicRecord = (index: number, data: ExamAnswer) => {
        let _t: ExamRightAnswer[] = [...record]
        _t[index].userAns = data
        setRecord(_t)
    };


    return (
        <ExamContext.Provider
            value={{
                isTesting: isTesting,
                examInfo: examInfo,
                examData: examData,
                record: record,
                setIsTesting: setBasicIsTesting,
                setRecord: setBasicRecord,
                updateRecord: updateBasicRecord,
                setExamInfo: setBasicExamInfo,
                setExamData: setBasicExamData,
            }}>
            {props.children}
        </ExamContext.Provider>
    )
}


